import axios from 'axios'
import Cookie from 'js-cookie'
import { loadToken, loadUserInfo } from '@/utils/cache'
import { ORIGIN_APIROOT, WEB_VERSION } from '@/config/config'
import client from '@/client/modules/common'
import { SDK_PRODUCT } from '@/config/dataMap'
import { signature } from './sign'

const service = axios.create({
  baseURL: ORIGIN_APIROOT, // api的base_url
  timeout: 5000 // request timeout
})

export const request = {
  /* eslint-disable-next-line */
  success (config) {
    const { subpid: spid = 0, fid: function_id = 0 } = window.app.$TidObj || {}
    const data = {
      common: {
        token: loadToken(),
        open_id: loadUserInfo() ? loadUserInfo().open_id : '',
        server_id: Cookie.get('svrid') || '',
        uuid: Cookie.get('uuid') || '',
        tryno: Cookie.get('tryno') || '',
        user_agent: 'web',
        web_version: WEB_VERSION,
        vip_version: Cookie.get('vip_version'),
        func_id: Cookie.get('func_id') || '',
        tid1: window.app.$TidObj.tid1 || 0,
        tid2: window.app.$TidObj.tid2 || 0,
        tod1: window.app.$TidObj.tod1 || 0,
        tod2: window.app.$TidObj.tod2 || 0,
        spid,
        function_id
      }
    }
    // common需要深度拷贝, 故需再次assign
    config.data = Object.assign(data, config.data, {
      common: Object.assign(
        data.common,
        (config.data && config.data.common) || {}
      )
    })

    // 产品ID
    config.headers.common['X-Cf-Productid'] = SDK_PRODUCT.id
    // 请求签名
    config.headers.common['X-Cf-Authorization'] = signature(JSON.stringify(config.data))
    // 毒霸大会员SDK版本号
    config.headers.common['X-Cf-Version'] = SDK_PRODUCT.version

    return config
  },
  error (err) {
    return Promise.reject(err)
  }
}

// http 请求拦截器
service.interceptors.request.use(request.success, request.error)

// http 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data.resp_common
    // 4001002 token过期
    if (res && res.ret === 4001002) {
      const name = window.app.$route.name
      if (name !== 'login' && name !== 'login2' && name !== 'login3') {
        window.app.$toast('登录信息已过期，请重新登录')
        window.app.$store.dispatch('user/setLoginStatus', 2)
        client.API.exit()
        window.app.$EventBus.$emit('logout')
      }
    }
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
